import React from 'react';
import MessageStatus from '@/pages/messages/components/message-status';
import MessageExpireTime from '../messageExpireTime';
import ContextMenuMessage from '../context-menu-message';
import MessageReply from '../message-reply';
import { deserializePayload } from '../../../chat-input/helpers';
import styles from './index.module.scss';
import type { MessageTextProps } from './type';

const MessageText: React.FC<MessageTextProps> = ({
  className,
  isMe,
  message,
  chat,
  chatMessages,
  chatGroup,
  handlers,
  setReplyMessage,
  onClickStatus,
  displayTime,
}) => {
  // TODO
  const hasInfo = false;
  const payloadChildren = useMemo(() => deserializePayload(message), [message]);

  const link_msg_id = useMemo(
    () => message?.link_msg_id.split('_')?.[0],
    [message?.link_msg_id]
  );

  return (
    <ContextMenuMessage message={message} chat={chat} setReplyMessage={setReplyMessage}>
      <div
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className={cls(
          styles.messageText,
          isMe && styles.messageTextBg,
          hasInfo && styles.hasInfo,
          className
        )}
      >
        {link_msg_id && (
          <MessageReply
            chat={chat}
            message={message}
            isMe={isMe}
            chatMessages={chatMessages}
            chatGroup={chatGroup}
            handlers={handlers}
          />
        )}
        <div className={styles.messageInfo}>
          <div className={styles.text}>{payloadChildren}</div>
          <div className={styles.operations}>
            {hasInfo && <div className={styles.left}></div>}
            <div className={styles.right}>
              <MessageExpireTime
                message={message}
                chat={chat}
                displayTime={displayTime}
              />
              <MessageStatus
                chat={chat}
                message={message}
                onClick={onClickStatus}
              ></MessageStatus>
            </div>
          </div>
        </div>
      </div>
    </ContextMenuMessage>
  );
};

export default MessageText;
